/* TGS2026 特設ページ用スクリプト
   _mockup/index.html から build_shopify.py で自動生成。直接編集しないこと。
*/
(function () {
  if (window.__tgs26Init) return;
  window.__tgs26Init = true;
  var root = document.querySelector('.tgs26');
  if (!root) return;

  /* ---------- schedule tabs ---------- */
  root.querySelectorAll('.day').forEach(b=>{
    b.addEventListener('click',()=>{
      root.querySelectorAll('.day').forEach(x=>x.classList.remove('on'));
      root.querySelectorAll('.panel').forEach(x=>x.classList.remove('on'));
      b.classList.add('on');
      root.querySelector('#' + b.dataset.day).classList.add('on');
    });
  });
  /* ---------- JP / EN ---------- */
  /* 言語は URL（?lang=en）に持たせる。DOMを書き換えるだけだと URL が変わらないので、
     英語表示のページを共有しても相手には日本語で表示されてしまう。
     /pages/○○-en のような英語専用ページを作った場合も EN で開く。 */
  root.querySelectorAll('[data-en]').forEach(el=>{ el.dataset.jp = el.innerHTML; });

  function tgsApplyLang(en){
    root.querySelectorAll('.langfloat button').forEach(x=>{
      x.classList.toggle('on', (x.dataset.lang === 'en') === en);
    });
    root.classList.toggle('en', en);
    document.documentElement.lang = en ? 'en' : 'ja';
    root.querySelectorAll('[data-en]').forEach(el=>{
      el.innerHTML = en ? el.dataset.en : el.dataset.jp;
    });
  }

  function tgsLangFromURL(){
    const v = new URLSearchParams(location.search).get('lang');
    if (v) return /^en/i.test(v);
    return /-en\/?$/.test(location.pathname);
  }

  function tgsWriteLang(en){
    try{
      const u = new URL(location.href);
      if (en) u.searchParams.set('lang', 'en'); else u.searchParams.delete('lang');
      history.replaceState(null, '', u);   // アドレスバーを共有できるURLにする（履歴は増やさない）
    }catch(e){}                            // file:// でモックを直接開いたときは失敗しうるので無視する
  }

  root.querySelectorAll('.langfloat button').forEach(b=>{
    b.addEventListener('click',()=>{
      const en = b.dataset.lang === 'en';
      tgsApplyLang(en);
      tgsWriteLang(en);
    });
  });

  tgsApplyLang(tgsLangFromURL());   // 読み込み時にURLの指定を反映する
})();
